export default "__VITE_ASSET__BgM4OVGJ__"